<div class="florder-page" @fadeInAnimation *ngIf="!loading">
  <div class="florder-page-title">
    <span class="title">
      {{ 'FLOWS.LIST.SUBTITLE' | translate }}
    </span>
    <div class="buttons">
      <eps-button
        (buttonClick)="createFlorder()"
        *ngIf="authorization.FLOW.CREATE"
        buttonIcon="plus-square"
        label="FLOWS.FILTER.BUTTONS.ADD_FLOW"
      ></eps-button>
    </div>
  </div>
  <div class="florder-page-search">
    <app-flow-filter
      [definitions]="definitions"
      [filter]="filter"
      [isBusy]="isDownloading"
      [isLoading]="ordersAreLoading"
      [customers]="customers"
      [filterValues]="filterValues"
      [shipTos]="shipTos"
      (filterFlows)="filterFlorders($event)"
      (resetFilterClicked)="resetFilter()"
    ></app-flow-filter>
  </div>
  <div class="florder-page-list" id="flow-list">
    <app-flow-list
      [authorization]="authorization"
      [definitions]="definitions"
      [filter]="filter"
      [isLoading]="ordersAreLoading"
      [isDownloading]="isDownloading"
      [flows]="flows.items"
      [totalItems]="flows.totalItems"
      [isSuperUser]="isSuperUser"
      [handshakingOrConfirming]="handshakingOrConfirming"
      [filterExcecutionTimestamp]="filterExcecutionTimestamp"
      [customersThatCanAcceptFlows]="sandbox.customersThatCanAcceptFlows$ | async"
      [customersThatCanUpsertFlows]="sandbox.customersThatCanUpsertFlows$ | async"
      (openFlow)="openFlow($event)"
      (downloadList)="downloadList($event)"
      (downloadDocument)="downloadDocument($event)"
      (acceptFlows)="acceptFlows($event)"
      (acceptFlow)="acceptFlow($event)"
      (cancelFlow)="cancelFlow($event)"
      (copyFlow)="copyFlow($event)"
      (editFlow)="editFlow($event)"
      (editDispute)="editDispute($event)"
      (editAcceptFlow)="editAcceptFlow($event)"
      (sortChange)="sortChange($event)"
      (pageChange)="onPageChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
    ></app-flow-list>
  </div>
</div>
